import { put, select } from 'typed-redux-saga';
import { CartsCookie } from '../../../dataloaders/CartsCookie';
import { OptionalStateCarts } from '@spa/lib/store/carts/CartsState';
import { anonymousUid } from '../../../const';
import logger from '../../../logger';
import selectCarts from '@spa/lib/store/carts/selectors/selectCarts';
import selectCartsCookie from '../../carts/selectors/selectCartsCookie';
import selectSessionAccessToken from '../../session/selectors/selectSessionAccessToken';
import { setCart } from '../../carts/cartsSlice';

function* removeAnonymousCartIfTokenUserTypeMismatchSaga(): Generator {
  const cartsCookie: CartsCookie = yield* select(selectCartsCookie);
  const carts: OptionalStateCarts = yield* select(selectCarts);
  for (const [key, { userType }] of Object.entries(cartsCookie)) {
    if (userType === anonymousUid) {
      const sessionAccessToken: string | null = yield* select(selectSessionAccessToken);
      const castedKey = key as keyof CartsCookie;

      if (carts[castedKey] !== null && sessionAccessToken === null) {
        logger.info(
          `Anonymous session token not available. Cleaning anonymous cart [CartType: ${castedKey}]`
        );
        yield* put(setCart({ localChange: true, cart: null, customOrderType: castedKey }));
      }
    }
  }
}

export default removeAnonymousCartIfTokenUserTypeMismatchSaga;
